(function () {
  'use strict';

  var markers = document.querySelectorAll('.article-featured-product[data-handle]');
  if (!markers.length) return;

  // Detect locale prefix from URL (e.g. "/en/" on .com)
  var localePrefix = '';
  var localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
  if (localeMatch) localePrefix = '/' + localeMatch[1];

  // Forward preview_theme_id so the embed can be previewed on an unpublished theme (no-op on live)
  var previewParam = '';
  var previewMatch = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
  if (previewMatch) previewParam = '&preview_theme_id=' + previewMatch[1];

  markers.forEach(function (marker) {
    var handle = marker.getAttribute('data-handle');
    var variationsAttr = marker.getAttribute('data-variations');
    var variationHandles = variationsAttr ? variationsAttr.split(',').map(function (s) { return s.trim(); }) : [];

    // Fetch the section + variation products in parallel
    var sectionPromise = fetch(localePrefix + '/products/' + handle + '?sections=article-product-embed' + previewParam, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.json(); });

    var variationPromises = variationHandles.map(function (h) {
      return fetch(localePrefix + '/products/' + h + '.js').then(function (r) { return r.json(); });
    });

    Promise.all([sectionPromise].concat(variationPromises))
      .then(function (results) {
        var sectionData = results[0];
        var variations = results.slice(1);

        var sectionHtml = sectionData['article-product-embed'];
        if (!sectionHtml) { marker.remove(); return; }

        var temp = document.createElement('div');
        temp.innerHTML = sectionHtml;

        var sectionEl = temp.firstElementChild;
        if (!sectionEl) { marker.remove(); return; }

        // Build color swatches HTML if we have multiple variations
        if (variations.length > 1) {
          var currentTitle = '';
          variations.forEach(function (v) {
            if (v.handle === handle) {
              currentTitle = v.title.split(' ').pop();
            }
          });

          var swatchesHtml = '<div class="product-info__product-picker">' +
            '<div class="variant-picker">' +
            '<fieldset class="variant-picker__option">' +
            '<div class="variant-picker__option-info">' +
            '<div class="h-stack gap-2">' +
            '<legend class="text-subdued">' + (localePrefix ? 'Color' : 'Couleur') + ' :</legend>' +
            '<span>' + currentTitle + '</span>' +
            '</div></div>' +
            '<div class="variant-picker__option-values wrap gap-2">';

          variations.forEach(function (v) {
            var isSelected = v.handle === handle;
            var colorName = v.title.split(' ').pop();
            var imgUrl = v.featured_image;
            if (imgUrl) {
              // Shopify CDN: get 120px version
              imgUrl = imgUrl.replace(/\.([a-z]+)(\?|$)/, '_120x120.$1$2');
            }

            swatchesHtml += '<a href="' + localePrefix + '/products/' + v.handle + '"' +
              ' class="thumbnail-swatch border' + (isSelected ? ' is-selected' : '') + '">' +
              '<span class="sr-only">' + colorName + '</span>';
            if (imgUrl) {
              swatchesHtml += '<img src="' + imgUrl + '" alt="' + colorName + '" width="60" height="60" class="object-cover" loading="lazy">';
            }
            swatchesHtml += '</a>';
          });

          swatchesHtml += '</div></fieldset></div></div>';

          // Insert swatches after the separator (before variant picker)
          var separator = sectionEl.querySelector('.product-info__separator');
          if (separator) {
            separator.insertAdjacentHTML('afterend', swatchesHtml);
          } else {
            var variantPicker = sectionEl.querySelector('.product-info__variant-picker');
            if (variantPicker) {
              variantPicker.insertAdjacentHTML('beforebegin', swatchesHtml);
            }
          }
        }

        // Tag forms with source property + GA4 tracking
        var forms = sectionEl.querySelectorAll('form.shopify-product-form');
        forms.forEach(function (form) {
          // Line item property: visible in Shopify admin orders
          var sourceInput = document.createElement('input');
          sourceInput.type = 'hidden';
          sourceInput.name = 'properties[_source]';
          sourceInput.value = 'article';
          form.appendChild(sourceInput);

          // GA4 custom event on form submit
          form.addEventListener('submit', function () {
            if (window.dataLayer) {
              var variantInput = form.querySelector('input[name="id"]');
              window.dataLayer.push({
                event: 'add_to_cart_article',
                article_url: window.location.pathname,
                product_handle: handle,
                variant_id: variantInput ? variantInput.value : ''
              });
            }
          });
        });

        // Wrap in afp-container
        var wrapper = document.createElement('div');
        wrapper.className = 'afp-section-container';
        wrapper.appendChild(sectionEl);

        // Move out of .prose to avoid its max-width: 85% constraint.
        // Place as a sibling inside .article-content instead.
        var prose = marker.closest('.prose');
        var articleContent = marker.closest('.article-content');

        if (prose && articleContent) {
          // Split the prose: content before marker stays, widget goes after prose,
          // content after marker goes into a new prose div.

          // Collect all siblings after the marker inside .prose
          var afterNodes = [];
          var sibling = marker.nextSibling;
          while (sibling) {
            afterNodes.push(sibling);
            sibling = sibling.nextSibling;
          }

          // Remove the marker from prose
          marker.remove();

          // Insert the widget after the prose element
          prose.insertAdjacentElement('afterend', wrapper);

          // If there's content after the marker, create a new prose div for it
          if (afterNodes.length > 0) {
            var hasContent = afterNodes.some(function (n) {
              return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim());
            });
            if (hasContent) {
              var proseAfter = document.createElement('div');
              proseAfter.className = 'prose';
              afterNodes.forEach(function (n) { proseAfter.appendChild(n); });
              wrapper.insertAdjacentElement('afterend', proseAfter);
            }
          }
        } else {
          // Fallback: replace marker in place
          marker.replaceWith(wrapper);
        }
      })
      .catch(function (err) {
        console.error('article-featured-product:', err);
      });
  });
})();
